import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { ExtraTimePayOptionsSchema, LOAD_ETP_SETTINGS_QUERY_KEY } from "./useLoadEtpSettings";
import { z } from "zod";
import { getAuthHeader } from "../../../../utils/superagent";
import request from "superagent";
import { getExtraTimePaySettingsDifferences } from "../helpers/form";

const SaveExtraTimePaySettingsSchema = z.object({
  workdayOptions: z.array(ExtraTimePayOptionsSchema).nullable().optional(),
  weeklyOption: ExtraTimePayOptionsSchema.nullable().optional(),
  isEditableByFacility: z.boolean().optional(),
});

export interface ExtraTimePaySettingsDifferences extends z.infer<
  typeof SaveExtraTimePaySettingsSchema
> {}

export interface SaveExtraTimePaySettingsArguments {
  previousSettings: Required<ExtraTimePaySettingsDifferences>;
  updatedSettings: ExtraTimePaySettingsDifferences;
}

export function useSaveEtpSettings(
  facilityId: string
): UseMutationResult<void, Error, SaveExtraTimePaySettingsArguments> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (variables) => {
      const { updatedSettings, previousSettings } = variables;

      const etpSettingsDifferences = getExtraTimePaySettingsDifferences({
        updatedSettings: SaveExtraTimePaySettingsSchema.parse(updatedSettings),
        previousSettings,
      });

      const response = await request
        // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
        .patch(`${global.api}/facilities/${facilityId}/extra-time-pay-settings`)
        .set(await getAuthHeader())
        .send({ data: etpSettingsDifferences });

      if (!response.ok) {
        throw new Error(`${response.statusCode}: Problem saving ETP settings for facility.`);
      }
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: [LOAD_ETP_SETTINGS_QUERY_KEY, facilityId] });
    },
  });
}
